/*
 File: sticky-header.js
 Author: D McCleod
 Created: 3/3/2017,
 Modified: 3/21/2017,
 Description: add sticky classes on scroll past slide title
 */

import * as config from './config';


const body = $('body');

var sticky = {};

sticky.init = function(disabled_flag){

    sticky.props = {
        ad: $('#adtagheader'),
        header: $('#headerbox'),
        byLine: $('.crs-header__contributors'),
        slideTop: $('.crs-top'),
        slideTop_collapsedHeight: 0,
        slideTop_height:  null,
        slideTop_heightDiff: 0,
        top_padding: 0,
        slideTopPos: null,
        returnHeight: null,
        classSet: false,
        stickyClass:'hasStickyHeader',
        scrollUp_to: null,
        breadcrumb: $('.crs-top_slideshows_link'),
        contrib: $('.crs-header__contributors'),
        isDisabled : disabled_flag.disable_sticky,
        // ie doesn't recognize the css 'initial' value
        initialVal: window.isIE ? 0 : 'initial',
        inFooter: false
    };

    sticky.props.slideTop_height = sticky.props.slideTop.height();

    if(sticky.props.isDisabled) sticky.props.ad.css('position', 'initial');

    if(breakpoint === 1){
        sticky.props.scrollUp_to = sticky.props.returnHeight = sticky.props.header.height();
        sticky.props.slideTopPos = 0;
    } else {
        let hasAd = sticky.props.isDisabled ? false : sticky.props.ad.height() > 20;

        sticky.props.scrollUp_to = !hasAd ? (sticky.props.slideTop.offset().top - sticky.props.slideTop_heightDiff) : sticky.props.ad.offset().top;
        sticky.props.slideTopPos = !hasAd ? 0 : sticky.props.ad[0].getBoundingClientRect().height;
        sticky.props.returnHeight = sticky.props.isDisabled ? sticky.props.byLine.height() : sticky.props.ad.offset().top + sticky.props.byLine.height();
        sticky.props.top_padding = breakpoint === 1 ? 0 : sticky.props.ad.height() + sticky.props.slideTop[0].getBoundingClientRect().height;

    }

    $(window).scroll(sticky.onScroll);
};

//check if element is in viewport
sticky.scrollIntoView = function(elem) {
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;

    return elemTop <= docViewBottom;
};

sticky.onScroll = function(){
    if($(window).scrollTop() >= sticky.props.scrollUp_to && !sticky.props.classSet) {
        body.addClass(sticky.props.stickyClass);
        // collapse bread crumb and contributors
        if(breakpoint !== 1) {
            sticky.props.breadcrumb
            .add(sticky.props.contrib)
            .slideUp();
            config.slideShowWrapper.css('padding-top', sticky.props.top_padding);
            sticky.props.slideTop.css('top', sticky.props.slideTopPos);
        }
        sticky.props.classSet = true;

    } else if($(window).scrollTop() <= sticky.props.scrollUp_to && sticky.props.classSet ) {
        body.removeClass(sticky.props.stickyClass);
        sticky.props.slideTop.css('top', (breakpoint === 1 ? 0 : sticky.props.initialVal) );
        // expand bread crumb and contributors
        if(breakpoint !== 1) sticky.props.breadcrumb.add(sticky.props.contrib).slideDown();
        sticky.props.classSet = false;
        config.slideShowWrapper.css('padding-top', sticky.props.initialVal);
    }

    //unstick header when footer is in viewport
    if (sticky.scrollIntoView($('#footercontents'))) {
        body.removeClass(sticky.props.stickyClass);
        sticky.props.slideTop.css('top', (breakpoint === 1 ? 0 : sticky.props.initialVal) );
        sticky.props.classSet = false;
        config.slideShowWrapper.css('padding-top', sticky.props.initialVal);
        sticky.props.inFooter = true;
    }
    else if (sticky.props.inFooter === true) {
        body.addClass(sticky.props.stickyClass);
        sticky.props.classSet = true;
        sticky.props.inFooter = false;
    }
};

export { sticky };